import React, { useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { Steps } from "../workflow/steps"
import { useStateMachine } from "../../context/stateMachine/StateMachineContext"
import useSubmitWithErrorCatch from "../hooks/useSubmitWithErrorCatch"
import {
  BenefitEnrollmentFlowModalBackButton,
  BenefitEnrollmentModalContinueButton,
  BenefitEnrollmentModalFormSelect
} from "../shared"
import { useCurrentUser } from "../../context/user/UserContext"
import { useUserDeductible } from "../../context/user/DeductibleContext"
import { GetWorkflow } from "./BenefitEnrollmentFlow"
import { FormattedMessage, useIntl } from "react-intl"
import { Box, Typography } from "@carrotfertility/carotene-core"
import { useProgressTracker } from "../../views/modal/ProgressTracker"

const FieldName = "areYouLegallyMarriedValue"
const ViewName = Steps.ARE_YOU_LEGALLY_MARRIED

function AreYouLegallyMarriedStep(): JSX.Element {
  const formMethods = useForm()
  const { legallyMarried, memberHasLegalPartner } = useCurrentUser()
  const { updateBenefitEnrollmentAnswers } = useUserDeductible()
  const { setNextStep } = useStateMachine(ViewName, legallyMarried)
  useStateMachine(ViewName, memberHasLegalPartner)
  const workflowType = GetWorkflow()
  // @ts-expect-error TS(7006) FIXME: Parameter 'args' implicitly has an 'any' type.
  const { onSubmit } = useSubmitWithErrorCatch(async (args) => {
    const val = args[FieldName].value
    val !== "IM_NOT_SURE" &&
      (await updateBenefitEnrollmentAnswers({
        legallyMarried: val
      }))
    setNextStep(ViewName, val)
  })
  const intl = useIntl()

  const { showProgress } = useProgressTracker()
  useEffect(showProgress, [showProgress])

  const { handleSubmit } = formMethods

  return (
    <FormProvider {...formMethods}>
      <Box paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.xxxl)}>
        <BenefitEnrollmentFlowModalBackButton />
      </Box>
      <Typography
        id="step-heading"
        variant="h2"
        color={(theme) => theme.palette.text.primary}
        paddingBottom={(theme) => theme.tokens.spacing.xs}
      >
        <FormattedMessage defaultMessage="Are you legally married?" />
      </Typography>
      <Box paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.xl)}>
        <Typography color={(theme) => theme.palette.text.secondary}>
          {workflowType === "CMD_HDHP"
            ? intl.formatMessage({
                defaultMessage:
                  "Your partner's medical coverage can affect how your Carrot benefit is taxed and whether any deductibles apply."
              })
            : intl.formatMessage({
                defaultMessage: "Your partner's medical coverage can affect how your Carrot funds are taxed."
              })}
        </Typography>
      </Box>
      <Box paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.xxxl)}>
        <BenefitEnrollmentModalFormSelect
          name={FieldName}
          aria-labelledby="step-heading"
          defaultValue={legallyMarried}
          options={[
            {
              label: intl.formatMessage({
                defaultMessage: "Yes"
              }),
              value: "true"
            },
            {
              label: intl.formatMessage({
                defaultMessage: "No"
              }),
              value: "false"
            }
          ]}
        />
      </Box>
      <Box height="18rem" />
      <BenefitEnrollmentModalContinueButton onClick={handleSubmit(onSubmit)} />
    </FormProvider>
  )
}

export { AreYouLegallyMarriedStep }
